export enum Producer {
    ESSILOR = 'essilor',
    SHAMIR = 'shamir'
}